import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DataLoadError from 'components/DataLoadError';

export default class ErrorBoundary extends Component {
  static displayName = 'ErrorBoundary';

  static propTypes = {
    children: PropTypes.node.isRequired,
    errorContent: PropTypes.node,
  };

  static defaultProps = {
    errorContent: <DataLoadError />,
  };

  state = {
    hasError: false,
  };

  componentDidCatch(error, info) {
    this.setState({
      hasError: true,
    });
    // eslint-disable-next-line no-console
    console.error('ErrorBoundary caught: ', { error, info });

    if (window.Sentry && window.Sentry.withScope) {
      window.Sentry.withScope(scope => {
        scope.setExtras(info);
        window.Sentry.captureException(error);
      });
    }
  }

  render() {
    const { children, errorContent } = this.props;

    if (this.state.hasError) {
      return errorContent;
    }

    return children;
  }
}
